import styled from 'styled-components'
import breakpoint from 'tools/styled-components-breakpoint'

export const MobileOnly = styled.div`
  /* stylelint-disable */
  ${breakpoint('desktop')`
    display: none;
  `}

  /* stylelint-enable */
`

export const MobileHidden = styled.div`
  /* stylelint-disable */
  ${breakpoint('mobile')`
    display: none;
  `}
  ${breakpoint('desktop')`
    display: block;
  `}
  /* stylelint-enable */
`

export const TabletHidden = styled.div`
  /* stylelint-disable */
  ${breakpoint('mobile')`
    display: block;
  `}
  ${breakpoint('tablet')`
    display: none;
  `}
  /* stylelint-enable */
`

export const TabletOnly = styled.div`
  /* stylelint-disable */
  ${breakpoint('mobile')`
    display: none;
  `}
  ${breakpoint('tablet')`
    display: block;
  `}
  /* stylelint-enable */
`
export const DesktopHidden = styled.div`
  /* stylelint-disable */
  ${breakpoint('mobile')`
    display: block;
  `}
  ${breakpoint('desktop')`
    display: none;
  `}
  /* stylelint-enable */
`

export const DesktopOnly = styled.div`
  /* stylelint-disable */
  ${breakpoint('mobile')`
    display: none;
  `}
  ${breakpoint('desktop')`
    display: ${props => props.display ? props.display : 'block'};
  `}
  /* stylelint-enable */
`
